<template>
    <a v-if="href" @click="clickAction" :href="href" :target="target">
        <slot/>
    </a>
    <div v-else>
        <slot/>
    </div>
</template>

<script>
import {getCurrentInstance, ref, toRefs} from "vue";
import {isDPlusLink, ApiUrl, fetchApiBridge} from "@/utils";
import {stripHtml} from "string-strip-html";
import {useI18n} from "vue-i18n";

export default {
    name: "anchor-parser",
    props: {
        href: {
            type: String,
            required: true
        },
        target: {
            type: String,
            default: null
        }
    },
    setup(props) {
        const {
            href,
            target
        } = toRefs(props);
        const view = ref(null);

        const { root } = getCurrentInstance();

        const { t } = useI18n();

        if (
            isDPlusLink(href.value)
        ) {
            view.value = "d-plus";
        }

        const clickAction = (e) => {
            if (view.value === "d-plus") {
                e.preventDefault();
                DPlusInit();
                //root.setupState.setDPlusLink(href.value);
            }
        }


        /**
         * D-Plus section start
         */

        const getText = (item, ns) => {
            if (item.assetType) {
                switch (item.assetType) {
                    case "component.factsheet.":
                        return item.factsheetText &&
                        item.factsheetText[DPlusLang] &&
                        item.factsheetText[DPlusLang][ns]
                            ? stripHtml(item.factsheetText[DPlusLang][ns]).result
                            : "";

                    case "component.webinar-on-demand.":
                        return item.webinarText &&
                        item.webinarText[DPlusLang] &&
                        item.webinarText[DPlusLang][ns]
                            ? stripHtml(item.webinarText[DPlusLang][ns]).result
                            : "";
                }
            }
            return "";
        };

        const checkEntityPath = (url) => {
            let path = url.split("/entity/");
            if (path.length !== 2) {
                return false;
            }
            return path[1];
        };

        const getImageObject = async (item) => {
            const content = {
                headline: getText(item,"headline"),
                subline: getText(item,"subheadline"),
                claim: item.assetType === 'component.webinar-on-demand.' ? t("dplus.modal.video.claim") : t("dplus.modal.factsheet.claim"),
                linkHref: href.value,
                linkLabel: t("dplus.modal.cta"),
                linkTarget: "_blank",
                textExpires: true
            };

            if (item.assetType==="component.factsheet.") {
                content.description = getText(item,"paragraph");
            }


            if (typeof item.mainPicture !== "undefined") {
                let path = checkEntityPath(item.mainPicture);
                if (path) {
                    if (typeof window.cardImages[path] !== "undefined") {
                        content.imageSrc = window.cardImages[path];
                        root.setupState.setModalDefaultContent(content);
                    } else {
                        fetchApiBridge("p=" + path, (res) => {
                            window.cardImages[path] =
                                ApiUrl +
                                "CenshareBridge?p=" +
                                checkEntityPath(res.variants["1300-500-dportal_teaser-media-news-events"].link);
                            content.imageSrc = window.cardImages[path];
                            root.setupState.setModalDefaultContent(content);
                        });
                    }
                }
            } else {
                root.setupState.setModalDefaultContent(content);
            }
        };

        let DPlusMap = null;
        let DPlusLang = "en";
        const DPlusInit = () => {
            const url = new URL(href.value);
            const params = url.searchParams;

            DPlusLang = url.pathname.substring(0,1)==="/"?
                url.pathname.substring(1):url.pathname;
            DPlusLang = DPlusLang.split('/');

            if (
                DPlusLang[0] === undefined ||
                ["en","de","cn","pt"].indexOf(DPlusLang[0]) === -1
            ) {
                DPlusLang = "en";
            } else {
                if (DPlusLang[0] === "cn")
                {
                    DPlusLang = "zh";
                }
                else {
                    DPlusLang = DPlusLang[0];
                }

            }

            let slug = params.get("slug");
            if (slug) {
                slug = slug.split(",")[0];
                if (slug!==""){
                    if (!DPlusMap) {
                        fetch(process.env.VUE_APP_PUBLIC_PATH + "js/dplus-fs-mappings.json")
                            .then(r => r.json())
                            .then(r => {
                                DPlusMap = r;
                                DPlusFetch(DPlusMap[slug]??null);
                            })
                    } else {
                        DPlusFetch(DPlusMap[slug]??null);
                    }
                } else {
                    DPlusFetch();
                }
            } else {
                let aid = params.get("aid");
                if (aid) {
                    if(aid === "") {
                        DPlusFetch();
                    } else if (aid.substring(0,1) === "[") {
                        aid = JSON.parse(aid);
                        DPlusFetch(aid[0]??null);
                    } else {
                        aid = aid.split(",");
                        DPlusFetch(aid[0]??null);
                    }
                } else {
                    DPlusFetch();
                }
            }
        }

        const DPlusFetch = (id=null) => {
            let query = [
                'factsheetText.*.language="' + DPlusLang + '"'
            ];

            if (id) {
                query.push('assetId=' + id + '');
            }

            query = query.length ? query.join("&") : "";

            if (query !== "") {
                query = "&query=" + encodeURIComponent(query);
            }

            fetchApiBridge(
                "p=" +
                process.env.VUE_APP_API_ENTRY +
                "&order=-assetId&limit=1" +
                query,
                (res) => {
                    if (typeof res.result !== "undefined") {
                        if (!res.result.length) {
                            DPlusFetch();
                        } else {
                            getImageObject(res.result[0]);
                        }
                    } else {
                        DPlusFetch();
                    }
                }
            );
        }
        /**
         * D-Plus section end
         */

        return {
            href,
            target,
            clickAction
        };
    }
}
</script>
